import { updatePaymentForm } from 'redux/actions/paymentForm';
import {
  GET_FORMS,
  NEW_EXTRA_FIELD,
  CLEAR_NEW_EXTRA_FIELD,
  UPDATE_EXTRA_FIELD,
  CLEAR_FORMS,
  PAYMENT_FORM_INPUT,
  SEND_PAYMENT_FORM_WHATSAPP,
  MODAL_FORM_QR,
  MODAL_SEND_MESSAGE,
  MODAL_DONE,
  CREATE_PAYMENT_FORM_QR_CODE,
} from 'redux/actions/types';

const initialState = {
  createNewForm: [],
  isLoading: true,
};

const forms = (state = initialState, { type, data }) => {
  switch (type) {
    case GET_FORMS:
      return {
        ...state,
        formItems: data.paymentForms,
        terminalItems: data.terminals,
        isLoading: false,
      };
    case NEW_EXTRA_FIELD:
      const newValues = state.createNewForm;
      newValues.push(data);
      return {
        ...state,
        createNewForm: newValues,
      };
    case PAYMENT_FORM_INPUT:
      return {
        ...state,
        newFormInput: data,
      };
    case MODAL_SEND_MESSAGE:
      return {
        ...state,
        modalAction: data,
      };
    case MODAL_FORM_QR:
      return {
        ...state,
        modalAction: data,
      };
    case SEND_PAYMENT_FORM_WHATSAPP:
      return {
        ...state,
        whatsAppLink: data.sendPaymentFormNotificationWhatsApp.link,
      };
    case CREATE_PAYMENT_FORM_QR_CODE:
      return {
        ...state,
        paymentFormQrCode: data?.image,
      };
    case UPDATE_EXTRA_FIELD:
      const updatedValues = state.createNewForm;
      updatedValues.filter(
        (i, index) => updatedValues[index] !== updatedValues[data.id]
      );
      updatedValues.push(data);
      return {
        ...state,
        createNewForm: updatedValues,
      };
    case CLEAR_NEW_EXTRA_FIELD:
      return {
        ...state,
        paymentFormQrCode: null,
      };
    case CREATE_PAYMENT_FORM_QR_CODE:
      return {
        ...state,
        createNewForm: [],
      };
    case CLEAR_FORMS:
      return {
        isLoading: true,
      };
    case MODAL_DONE:
      return {
        ...state,
        modalAction: null,
      };
    default:
      return state;
  }
};

export default forms;
